var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ugc-viewer"},[(_vm.ugcUrl)?_c('img',{attrs:{"src":_vm.ugcUrl}}):_c('img',{attrs:{"src":"/images/sample.jpg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }